module.exports = __webpack_public_path__ + "static/PP6s-c73696d8b8143da4bbf877f727c4118c.jpg";